import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=0ff870ef&scoped=true"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"
import style0 from "./Radio.vue?vue&type=style&index=0&id=0ff870ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff870ef",
  null
  
)

export default component.exports